"use client";
import { jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import HelperText from "./HelperText.mjs";
import cx from "classnames";
const CharacterCount = (props) => {
  const {
    prefix = "",
    targetID,
    limit = 0,
    characterCount,
    onStateChange,
    ...otherProps
  } = props;
  const [count, setCount] = useState(0);
  function handleChange(event) {
    const target = event.target;
    if (target) {
      setCount((target.value || target.textContent || "").length);
    }
  }
  useEffect(() => {
    if (characterCount || characterCount === 0) {
      setCount(characterCount);
      return;
    }
    if (!targetID) return;
    const target = document.getElementById(targetID);
    if (target) {
      target.addEventListener("input", handleChange, { passive: true });
      target.addEventListener("change", handleChange, { passive: true });
      if (target.value) setCount(String(target.value).length);
    }
    return () => {
      if (target) {
        target.removeEventListener("input", handleChange);
        target.removeEventListener("change", handleChange);
      }
    };
  }, [targetID, characterCount]);
  const stateCache = React.useRef(false);
  useEffect(() => {
    const nextState = count <= limit;
    if (onStateChange && stateCache.current !== nextState)
      onStateChange(nextState);
    stateCache.current = nextState;
  }, [count]);
  return /* @__PURE__ */ jsx(
    HelperText,
    {
      prefix,
      ...otherProps,
      className: cx(
        `${prefix}helper-text--character-count`,
        otherProps.className
      ),
      textOnly: true,
      shouldValidate: count > limit,
      valid: false,
      children: `${count}/${limit}`
    }
  );
};
CharacterCount.displayName = "CharacterCount";
var CharacterCount_default = CharacterCount;
export {
  CharacterCount,
  CharacterCount_default as default
};
